var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPreviousIcon = function SvgPreviousIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.167 1.333A1.333 1.333 0 0 0 20 .293L6.667 10.958a1.333 1.333 0 0 0 0 2.082L20 23.708a1.333 1.333 0 0 0 2.167-1.041zM3.5 2.667a1.333 1.333 0 1 0-2.667 0v18.666a1.333 1.333 0 1 0 2.667 0z"
  })));
};
export default SvgPreviousIcon;